/* ---- THE COIN BOX · single-machine page: gate STEP UP / PLAY ---- */
(function(){
  var CB = window.STATION_COINBOX; if (!CB) return;
  var ID = window.STATION_GAME_ID; if (!ID) return;
  function chip(){
    var host = document.querySelector('.row'); if (!host) return null;
    var c = document.getElementById('coinChip');
    if (!c){ c = document.createElement('span'); c.id='coinChip';
      c.style.cssText='display:inline-flex;align-items:center;gap:8px;padding:10px 13px;border-radius:999px;font-family:"IBM Plex Mono",monospace;font-size:11px;letter-spacing:.14em';
      host.appendChild(c); }
    return c;
  }
  function paint(){
    var free = CB.isFree(ID), c = chip(); if (!c) return;
    c.style.border = '1px solid ' + (free ? 'rgba(0,206,126,.55)' : '#F0C75E');
    c.style.color = free ? '#00CE7E' : '#F0C75E';
    c.textContent = (free ? 'FREE PLAY \u00B7 THIS ROTATION' : '25\u00A2 \u00B7 ONE PLAY \u00B7 TOKENS: ' + CB.tokens()) + ' \u00B7 DIAL TURNS ' + CB.clock();
    var b = document.getElementById('playBtn');
    if (b && !free && !b.dataset.coinLbl){ b.dataset.coinLbl = b.textContent; }
    if (b) b.textContent = free ? (b.dataset.coinLbl || b.textContent) : 'INSERT 25\u00A2';
  }
  document.addEventListener('click', function(e){
    var b = e.target.closest && e.target.closest('#playBtn'); if (!b) return;
    if (CB.isFree(ID)) { CB.played(ID); return; }
    if (CB.spend(ID)) { paint(); return; }
    e.preventDefault(); e.stopImmediatePropagation();
    var t = document.getElementById('coinToast');
    if (t){ t.hidden = false;
      t.innerHTML = 'THIS MACHINE WANTS A QUARTER \u00B7 <a href="' + CB.buyUrl + '">GET TOKENS</a> \u00B7 <a href="/?view=arcade">FIND A FREE ONE</a>';
      clearTimeout(window.__ctT); window.__ctT = setTimeout(function(){ t.hidden = true; }, 4200); }
  }, true);
  window.addEventListener('coinbox', paint);
  paint();
})();


/* V190 · THE HIGH SCORE — every game with a score keeps your best on this device, under your initials; the station's own rules, no server */
(function(){
  var d = document, sc = d.getElementById('sScore'); if (!sc) return;
  var key = 'station.best.' + ((window.STATION_GAME_ID) || location.pathname.replace(/[^a-z0-9]+/gi, '-'));
  var best = 0, ini = ''; try { best = +localStorage.getItem(key) || 0; ini = localStorage.getItem('station.initials') || ''; } catch(e){}
  var tag = d.createElement('span'); tag.className = 'gp-best'; tag.setAttribute('aria-live', 'polite');
  tag.style.cssText = 'display:inline-flex;align-items:center;gap:8px;margin-left:12px;padding:3px 9px;border:1px solid rgba(240,199,94,.5);border-radius:999px;font:700 10px/1.6 ui-monospace,Menlo,monospace;letter-spacing:.16em;color:#F0C75E;vertical-align:middle';
  var host = sc.parentElement || sc; host.appendChild(tag);
  function paint(){ tag.textContent = best ? ('BEST ' + best.toLocaleString() + (ini ? ' \u00b7 ' + ini : '')) : 'NO BEST YET'; }
  function askInitials(){
    if (ini) return;
    var box = d.createElement('span'); box.style.cssText = 'display:inline-flex;gap:6px;margin-left:10px;vertical-align:middle';
    var inp = d.createElement('input'); inp.maxLength = 3; inp.placeholder = 'AAA'; inp.setAttribute('aria-label', 'Your initials'); inp.style.cssText = 'width:52px;padding:3px 6px;border:1px solid rgba(240,199,94,.5);border-radius:6px;background:transparent;color:#F0C75E;font:700 11px ui-monospace,Menlo,monospace;letter-spacing:.2em;text-transform:uppercase';
    var ok = d.createElement('button'); ok.type = 'button'; ok.textContent = 'SIGN'; ok.style.cssText = 'padding:3px 9px;border:0;border-radius:6px;background:#F0C75E;color:#05070C;font:700 10px ui-monospace,Menlo,monospace;letter-spacing:.16em;cursor:pointer';
    ok.addEventListener('click', function(){ ini = (inp.value || '').toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 3); if (!ini) return; try { localStorage.setItem('station.initials', ini); } catch(e){} box.remove(); paint(); });
    box.appendChild(inp); box.appendChild(ok); host.appendChild(box);
  }
  function check(){ var n = parseInt(String(sc.textContent).replace(/[^0-9]/g, ''), 10); if (isNaN(n)) return; if (n > best) { best = n; try { localStorage.setItem(key, String(best)); } catch(e){} paint(); if (!ini) askInitials(); } }
  paint();
  try { new MutationObserver(check).observe(sc, { childList: true, characterData: true, subtree: true }); } catch(e){ setInterval(check, 1000); }
})();
